import apiFetch from '../apiFetch'
export default function (token, body) {
  return apiFetch({ endPoint: 'UnattendedProcess/ExportUnattendedProcessTypes', method: 'POST', body: body, token: token, parseBlobAndAssign: true })
}
